/**
 * extracted from typeahead.js
 */

export const isMobile = () => {
  const MOBILE_WIDTH = 961
  const screenWidth = window.innerWidth;

  return screenWidth < MOBILE_WIDTH;
};
